import http from '@/http/aisea/axios'
const resource = "/enterprises";

export default {

  // 法人Adminアカウント認証登録の検証
  verification(enterpriseLoginKey, payload) {
    return http.get(`${resource}/${enterpriseLoginKey}/admins/accounts/certificates`, {
      params: payload
    });
  },

  // 法人Adminアカウント認証登録
  update(enterpriseLoginKey, payload) {
    return http.post(`${resource}/${enterpriseLoginKey}/admins/accounts/certificates`, payload);
  },

};


